import { defineComponent as _defineComponent } from 'vue'
import { TwiageCase } from "@/Case/models/TwiageCase";
import A11yDialog from "a11y-dialog";
import { onMounted, ref, watch } from "vue";
import Dialog from "./Dialog.vue";
import ProtocolDialog from "./ProtocolDialog.vue";
import { useProtocolStore } from "./store/protocol-store";
import { EmtLevel } from "./types/QuestionParams";


export default /*#__PURE__*/_defineComponent({
  __name: 'Protocol',
  props: {
    twiageCase: null
  },
  setup(__props: any) {

const props = __props as { twiageCase: TwiageCase | null };



const protocolDialog = ref<InstanceType<typeof ProtocolDialog> | null>(null);

const protocolStore = useProtocolStore();

let emtLevelDialog: A11yDialog | undefined = undefined;

const emtLevelDialogRef = ref<{ getDialog: () => A11yDialog }>();

onMounted(() => {
  emtLevelDialog = emtLevelDialogRef.value?.getDialog();
});

watch(
  () => props.twiageCase,
  (newCase) => {
    protocolStore.setContext(newCase);
  },
  { immediate: true },
);

const show = () => {
  // Sets context and clears conversation if context changed
  // (e.g., opening from Start screen after being in a case will reset state)
  protocolStore.setContext(props.twiageCase);

  if (protocolStore.shouldShowEmtLevel.value && protocolStore.emsLevels.value.length > 0) {
    emtLevelDialog?.show();

    return;
  }

  protocolDialog.value?.show();
};

const handleNewQuestion = ({ question }: { question?: string }) => {
  return protocolStore.handleNewQuestion(question);
};

const handleEmsLevelSubmit = (event: Event) => {
  const data = new FormData(event.target as HTMLFormElement);
  const emsLevel = data.get("emsLevel") as EmtLevel;
  protocolStore.saveEmsLevel(emsLevel);
  emtLevelDialog?.hide();
  protocolDialog.value?.show();
};

const handleNewContext = () => {
  protocolStore.handleNewContext();
};

return { __sfc: true,props, protocolDialog, protocolStore, emtLevelDialog, emtLevelDialogRef, show, handleNewQuestion, handleEmsLevelSubmit, handleNewContext, Dialog, ProtocolDialog }
}

})